import { useSetRecoilState } from "recoil";
import { snackbarAtom } from "../atoms";

export default function useSnackbar() {
	const openSnackbar = useSetRecoilState(snackbarAtom);

	return openSnackbar;
}
